import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PbdsDatavizGauge } from '@precisely/design-system';
import { UserService } from '../service/user.service';
import { Observable, of } from 'rxjs';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import * as L from "leaflet";
import * as $ from 'jquery';
import { debounceTime, distinctUntilChanged, switchMap, catchError } from 'rxjs/operators';
declare const recurly: any;

@Component({
  selector: 'geotax',
  templateUrl: './geotax.component.html',
  providers: [NgbModalConfig, NgbModal]
})
export class GeotaxComponent implements OnInit {
  @ViewChild('accountStatusModal', { static: false }) accountStatusModalEl: ElementRef;
  @ViewChild('freeBatchModal', { static: false }) freeBatchModalEl: ElementRef;
  @ViewChild('freeOverageModal', { static: false }) freeOverageModalEl: ElementRef;
  @ViewChild('lowConfidenceModal', { static: false }) lowConfidenceModalEl: ElementRef;
  @ViewChild('batchMapModal', { static: false }) batchMapModalEl: ElementRef;
  @ViewChild('enterCardModal', { static: false }) enterCardModalEl: ElementRef;
  @ViewChild('contactAdminModal', { static: false }) contactAdminModalEl: ElementRef;
  public isNeToUpIm: boolean = false;
  public isPaymentFormOpen: boolean = false;
  public isPaymentErr: boolean = false;
  public isPaymentSuccess: boolean = false;
  public paymentErrMsg: string = '';
  public map;
  public isavailable;
  public highestConScore: boolean = false;
  public highConScore: boolean = false;
  public lowConScore: boolean = false;
  public conTooltipMsg: string = '';
  mainAddressLine = '';
  addressLastLine = '';
  showMatchAddress = false;
  showConfidenceTooltip = false;
  rightposflag = '71px';
  markers: L.Layer[] = [];
  markerIcon = {
    icon: L.icon({
      iconSize: [36, 54],
      iconAnchor: [18, 54],
      popupAnchor: [0, -40],
      iconUrl: '/assets/images/defaultmarker.svg'
    })
  };
  newMarker;
  public lat;
  public long;
  public flag;
  public firstName: string = '';
  public lastName: string = '';
  public addressLine1: string = '';
  public addressLine2: string = '';
  public city: string = '';
  public stateprovince: string = 'AL';
  public postalCode: any = '';
  public showConfirmAddr: boolean = false;
  public verifiedAddrRes: any;
  public confirmAddrRadio: any = null;
  public stateMap = {
    AL: "Alabama", AK: "Alaska", AZ: "Arizona", AR: "Arkansas", CA: "California", CO: "Colorado", CT: "Connecticut", DE: "Delaware", DC: "District Of Columbia", FL: "Florida", GA: "Georgia", HI: "Hawaii", ID: "Idaho", IL: "Illinois", IN: "Indiana", IA: "Iowa", KS: "Kansas", KY: "Kentucky", LA: "Louisiana", ME: "Maine", MD: "Maryland", MA: "Massachusetts", MI: "Michigan", MN: "Minnesota", MS: "Mississippi", MO: "Missouri", MT: "Montana", NE: "Nebraska", NV: "Nevada", NH: "New Hampshire", NJ: "New Jersey", NM: "New Mexico", NY: "New York", NC: "North Carolina", ND: "North Dakota", OH: "Ohio", OK: "Oklahoma", OR: "Oregon", PA: "Pennsylvania", RI: "Rhode Island", SC: "South Carolina", SD: "South Dakota", TN: "Tennessee", TX: "Texas", UT: "Utah", VT: "Vermont", VA: "Virginia", WA: "Washington", WV: "West Virginia", WI: "Wisconsin", WY: "Wyoming"
  };
  addMarker(long, lat) {
    if (this.map) {
      if (this.newMarker != undefined && this.flag != true) {
        this.map.removeLayer(this.newMarker);
      };
      this.newMarker = L.marker([long, lat], this.markerIcon).addTo(this.map);
    }
  }
  onMapReady(map: L.Map) {
    this.map = map;
  }
  onhalfmonReaday() {
    //this.halfmoon= this.halfmoon;
  }

  public activeTab: string = "singletax";
  public currentTaxRate: string = "General";
  public taxAmount: number;
  public planId: string = "";
  public planName: string = "";
  public billPeriod: string = "";
  public transactionMsg: any = "";
  public isdevice: boolean = false;
  public endYear: number = (new Date()).getFullYear();
  public modelYear: number = this.endYear;
  public arrYear: any = ['Select'];
  public showupgradelink: boolean = false;
  public hasPastDue: boolean = true;
  public hasFutSubs: boolean = true;
  private upgradablePlanIdArr = ['GT_General_Auto_Free_10_14Day', 'GT_General_Auto_Basic_Monthly', 'GT_General_Auto_100_Monthly'];
  private planObj = {
    GT_General_Auto_Free_10_14Day: 'Free Trial',
    GT_General_Auto_Basic_Monthly: 'GeoTax 15 Monthly',
    GT_General_Auto_100_Monthly: 'GeoTax 100 Monthly',
    GT_General_Auto_100_Annual: 'GeoTax 100 Annual'
  };
  public isOverage: boolean = false;
  public circle: PbdsDatavizGauge = {
    minvalue: 0,
    maxvalue: 360,
    value: 0
  };
  public subscriptionState: string = "";
  public subscriptionStartDate: string = "";
  public subscriptionEndDate: string = "";
  public currentQuotaPeriodStartDate;
  public nextQuotaPeriodStartDate: string = "";
  public entitlementsStatus: string = "";
  public isCancelledEntitlement: boolean = false;
  public isValidEntitlement: boolean = true;
  public userExpiredMsg: string = "";
  public userExpiredTitle: string = "";
  public isDialReady: boolean = false;
  public showLoader: boolean = false;
  public makeModel: any;
  public totalPointsUsed: any;
  public quota: any;
  public totalPayLoadCount: number = 0;
  public totalResCount: number = 0;
  public successPayLoadCount: number = 0;
  public errorPayLoadCount: number = 0;
  public batchColumns: any;
  public batchResponse: any = [];
  public isBatchResultReady: boolean = false;
  public batchErr: string = "";
  public batchModalErr: string = "";
  public modalwarning: string = "";
  public batchfilename: string = "";
  public batchfilenamedup: string = "";
  public idCol = "";
  public addressCol = "";
  public cityCol = "";
  public stateCol = "";
  public zipCol = "";
  public amountCol = "";
  public columnArr = [];
  public fileDataArr = [];
  private httpObj: any = null;
  public showpage: boolean = false;
  public userRole: string = '';
  private creditCardAndFreePlansList = new Set(["GT_General_Auto_100_Annual", "GT_General_Auto_100_Monthly", "GT_General_Auto_Basic_Monthly", "GT_General_Auto_Free_10_14Day"]);

  public options = {
    layers: [
      //this.mapLayers = [L.tileLayer('/tryApiRasterMaps?row={y}&column={x}&zoomLevel={z}&type=leaflet&theme=' + this.mapthemeRadio, { maxZoom: 18, attribution: '<a rel="noopener noreferrer" target="_blank" href="http://www.openstreetmap.org/copyright">&copy; OpenStreetMap contributors</a>' })];
      L.tileLayer('/tryApiRasterMaps?row={y}&column={x}&zoomLevel={z}&type=leaflet&theme="bronze"', { minZoom: 2, attribution: '<a rel="noopener noreferrer" target="_blank" href="http://www.openstreetmap.org/copyright">&copy; OpenStreetMap contributors</a>'})
//      L.tileLayer(localStorage.getItem("mapFullURL"), { minZoom: 2, attribution: '<a rel="noopener noreferrer" target="_blank" href="http://www.openstreetmap.org/copyright">&copy; OpenStreetMap contributors</a>' })
    ],
    zoom: 17,
    center: L.latLng(46.8523, -121.7603)
  };


  showMap;
  constructor(private router: Router, private activatedRoute: ActivatedRoute, private userService: UserService, config: NgbModalConfig, private modalService: NgbModal) {
    config.backdrop = 'static';
    config.keyboard = false;
  };
  makeModelSearch = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      switchMap(term =>
        this.userService.searchMakeModel(term).pipe(
          catchError(() => {
            return of([]);
          })
        )
      )
    )
  makeModelFrmatter = (x: { label: string }) => x.label;

  ngOnInit() {
    this.userService.getResources().subscribe(
      success => {
          //localStorage.setItem("mapFullURL", 'https://api.precisely.com/maps/v1/tile/osm/{z}/{x}/{y}.png?api_key=' + success['apiKey'] + '&theme=bronze');
          localStorage.setItem("recurlyConfig", success['recurlyConfig']);
          localStorage.setItem("signUpURL", success['signUpURL']);
      }
  );
    this.showMap = false;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.isdevice = true;
    }
    for (let i = this.endYear; i >= 2001; i--) {
      this.arrYear.push(i);
    }
    let userData = null;
    this.userService.getUserDeatails().subscribe(
      success => {
        userData = success;
        this.showpage = true;
        if (userData.subscriptions.geotax) {
          this.subscriptionState = userData.subscriptions.geotax.subscriptionState;
          this.subscriptionEndDate = userData.subscriptions.geotax.endDate;
          this.subscriptionStartDate = userData.subscriptions.geotax.startDate;
          this.currentQuotaPeriodStartDate = userData.subscriptions.geotax.currentQuotaPeriodStartDate;
          this.nextQuotaPeriodStartDate = userData.subscriptions.geotax.nextQuotaPeriodStartDate;
        }
        if (userData.entitlements.length > 0) {
          if (userData.entitlements[0].product === "geotax") {
            this.userRole = userData.entitlements[0].role;
            this.planId = userData.entitlements[0].plan;
            this.planName = this.planId;
            if (this.planId in this.planObj) {
              this.planName = this.planObj[this.planId];
            }
            else if (this.planId.includes('Free')) {
              this.planName = 'Free Trial';
            }
            this.entitlementsStatus = userData.entitlements[0].status.toLowerCase();
            if (this.entitlementsStatus == 'cancelled') {
              this.isCancelledEntitlement = true;
            }
            if (this.entitlementsStatus == 'cancelled' || this.entitlementsStatus == 'suspended') {
              this.isValidEntitlement = false;
            }
            this.dialInit();
            if(this.userRole === "AdminWithBilling" || this.userRole === "FinanceAdmin"){
              let recai = userData.entitlements[0].recai;
              if (recai) {
                if (this.planId == 'GT_General_Auto_Basic_Monthly' || this.planId == 'GT_General_Auto_100_Monthly' || this.planId == 'GT_General_Auto_100_Annual') {
                  this.getUserAccountDetails();
                }
                else {
                  this.hasPastDue = false;
                  this.hasFutSubs = false;
                }
              }
              else {
                alert("User without recurly account id.");
              }
            }
          }
        }
        this.checkUserStaus();
      },
      error => {
        window.location.href = "/";
      }
    );
  };
  checkUserStaus = function () {
    if (this.entitlementsStatus == 'cancelled') {
      this.userExpiredMsg = 'Your current subscription has cancelled. To re-subscribe, please sign out and sign up.';
      this.userExpiredTitle = 'Account Cancelled';
    }
    else if (this.entitlementsStatus == 'suspended') {
      this.userExpiredMsg = 'Your current subscription is suspended. To re-enable your subscription, please make sure your past due payments are clear and update your credit card details. In case of any further questions, please contact <a href="https://support.precisely.com/products/geotax-com/" rel="noopener noreferrer" target="_blank" tabindex="-1">support</a>.';
      this.userExpiredTitle = 'Account Suspended';
    }
    else if (this.subscriptionState != 'active') {
      let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      let isoDate = new Date(this.subscriptionEndDate);
      let isoDateStr = monthNames[isoDate.getMonth()] + " " + isoDate.getDate() + ", " + isoDate.getFullYear();
      if (this.planId.includes('Free')) {
        this.userExpiredMsg = 'Your free trial has expired. Please upgrade your plan <a href="/pricing"  tabindex="-1">here</a> or contact <a href="https://support.precisely.com/products/geotax-com/" rel="noopener noreferrer" target="_blank" tabindex="-1">support</a>. Your plan expired on ' + isoDateStr + '.';
        this.userExpiredTitle = 'Free Trial Expired';
      }
      else {
        this.userExpiredMsg = 'Your service plan has expired. Please upgrade your plan <a href="/pricing" tabindex="-1">here</a> or contact <a href="https://support.precisely.com/products/geotax-com/" rel="noopener noreferrer" target="_blank" tabindex="-1">support</a>. Your plan expired on ' + isoDateStr + '.';
        this.userExpiredTitle = 'Account Term Expired';
      }
    }
    if (this.userExpiredMsg != "") {
      setTimeout(() =>
        this.modalService.open(this.accountStatusModalEl, { size: 'md', ariaLabelledBy: 'modal-basic-title' })
      );
    }
  };
  getUserAccountDetails = function () {
    this.userService.getUserAccountDetailsById().subscribe(
      success => {
        this.hasPastDue = success.data[0].has_past_due_invoice;
        this.hasFutSubs = success.data[0].has_future_subscription;
      },
      error => {
        if (error.error.error == 'Cookie tempered') {
          window.location.href = '/signout';
        }
      }
    );
  };
  dialInit = function () {
    //this.isDialReady = false;
    this.userService.getUsage().subscribe(
      success => {
        this.isDialReady = true;
        this.totalPointsUsed = success.totalPointsUsed;
        this.quota = success.quota;
        this.circle.value = this.totalPointsUsed;
        this.circle = {
          minvalue: 0,
          maxvalue: this.quota,
          value: this.totalPointsUsed
        };
        if (this.totalPointsUsed > this.quota) {
          this.isOverage = true;
          this.transactionMsg = (this.totalPointsUsed - this.quota);
          if (this.upgradablePlanIdArr.includes(this.planId) || this.planId.includes('Free')) {
            this.showupgradelink = true;
          }
        }
        else {
          this.transactionMsg = (this.quota - this.totalPointsUsed);
          let percentageRem = (this.quota - this.totalPointsUsed) / this.quota;
          if (percentageRem <= 0.1) {
            if (this.upgradablePlanIdArr.includes(this.planId) || this.planId.includes('Free')) {
              this.showupgradelink = true;
            }
          }
        }
        let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        let date;
        let dateTo;

        if (this.creditCardAndFreePlansList.has(this.planId)) {
          date = new Date(this.currentQuotaPeriodStartDate);
          dateTo = new Date(this.nextQuotaPeriodStartDate);
        }
        else {
          date = new Date(this.subscriptionStartDate);
          if (this.subscriptionEndDate != null) {
            dateTo = new Date(this.subscriptionEndDate);
          }
          else {
            let todayTime = new Date().getTime();
            dateTo = new Date(todayTime);
          }

        }

        //if(date != "Invalid Date" && dateTo != "Invalid Date"){
        let Year = date.getFullYear();
        let months = date.getMonth();
        let day = date.getDate();
        let fromDateStr = day + "-" + monthNames[months] + "-" + Year;

        let dateOffset = 1;
        dateTo.setDate(dateTo.getDate() - dateOffset);
        let YearTo = dateTo.getFullYear();
        let monthsTo = dateTo.getMonth();
        let dayTo = dateTo.getDate();

        let toDateStr = dayTo + "-" + monthNames[monthsTo] + "-" + YearTo;
        this.billPeriod = fromDateStr + " To " + toDateStr;
        //}
      },
      error => {
        if (error.error.error == 'Cookie tempered') {
          window.location.href = '/signout';
          return;
        }
        this.isDialReady = true;
      }
    );
  };
  toggleTab = function (tabType) {
    this.currentTaxRate = "General";
    var that = this;
    if (tabType == "batchtax") {
      // this.currentTaxRate = "";
      // this.currentTaxRate = "General";
      if (this.planId.includes('Free')) {
        setTimeout(() =>
          this.modalService.open(this.freeBatchModalEl, { size: 'md', ariaLabelledBy: 'modal-basic-title' })
        );
      }
      else {
        this.activeTab = "batchtax";
      }
    }
    else {
      if ((<HTMLInputElement>document.getElementById("taxRateResult")) === null) {
        this.showMap = false;
      }
      if (this.lat != undefined && this.long != undefined) {
        if (this.map) {
          this.options = {
            layers: [
              L.tileLayer('/tryApiRasterMaps?row={y}&column={x}&zoomLevel={z}&type=leaflet&theme="bronze"', { minZoom: 2, attribution: '<a rel="noopener noreferrer" target="_blank" href="http://www.openstreetmap.org/copyright">&copy; OpenStreetMap contributors</a>'})

//              L.tileLayer(localStorage.getItem("mapFullURL"), { minZoom: 2, attribution: '<a rel="noopener noreferrer" target="_blank" href="http://www.openstreetmap.org/copyright">&copy; OpenStreetMap contributors</a>' })
            ],
            zoom: 17,
            center: L.latLng(that.lat, that.long)
          };
          setTimeout(() => {
            this.flag = true;
            this.addMarker(this.lat, this.long);
          }, 1000);
          this.map.panTo(new L.LatLng(this.lat, this.long));
        }
      }
      else {
        this.options = {
          layers: [
            L.tileLayer('/tryApiRasterMaps?row={y}&column={x}&zoomLevel={z}&type=leaflet&theme="bronze"', { minZoom: 2, attribution: '<a rel="noopener noreferrer" target="_blank" href="http://www.openstreetmap.org/copyright">&copy; OpenStreetMap contributors</a>'})

            //L.tileLayer(localStorage.getItem("mapFullURL"), { minZoom: 2, attribution: '<a rel="noopener noreferrer" target="_blank" href="http://www.openstreetmap.org/copyright">&copy; OpenStreetMap contributors</a>' })
          ],
          zoom: 17,
          center: L.latLng(46.8523, -121.7603)
        };
      }
      this.onMapReady(this.map);
      this.activeTab = "singletax";
    }
  };
  onKeyDown = function (event) {
    // prevent: "e", "=", ",", "-"
    if ([69, 187, 188, 189].includes(event.keyCode)) {
      event.preventDefault();
    }
  };
  numberWithCommas = function (x: number) {
    var tmpStrArr = x.toFixed(2).toString().split('.');
    var tmpStr = tmpStrArr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (tmpStrArr[1]) {
      tmpStr += '.' + tmpStrArr[1];
    }
    return tmpStr;
  };
  public confidenceFlag;
  getTaxRate = function () {
    if (this.userExpiredMsg == '') {
      this.showLoader = true;
      let taxRateTypeId = this.currentTaxRate;
      let address = (<HTMLInputElement>document.getElementById("geosearchwidgetinput")).value;
      let purchaseAmount = this.taxAmount;
      var resultData;
      if (address != "") {
        let queryStr = "?taxRateTypeId=" + taxRateTypeId;
        queryStr += "&address=" + encodeURIComponent(address);
        if (purchaseAmount) {
          if (!isNaN(purchaseAmount)) {
            queryStr += "&purchaseAmount=" + purchaseAmount;
          }
          else {
            this.showMap = false;
            document.getElementById('taxRateResult').innerHTML = '<div class="alert alert-danger errmargin">Amount is invalid.</div>';
            this.showLoader = false;
            this.showMatchAddress = false;
            return;
          }
        }
        if (taxRateTypeId == 'Auto') {
          let makeModel = "";
          if (this.makeModel) {
            if (this.makeModel.label) {
              makeModel = this.makeModel.label;
            }
            else {
              makeModel = this.makeModel;
            }
          }
          if (makeModel != "") {
            queryStr += "&fullAutoModel=" + makeModel.substring(0, 50).trim();
            if (this.modelYear != 'Select') {
              queryStr += "&Year=" + this.modelYear;
            }
            if (this.makeModel.Make) {
              queryStr += "&Make=" + this.makeModel.Make;
            }
            if (this.makeModel.Model) {
              queryStr += "&Model=" + this.makeModel.Model;
            }
            if (this.makeModel.Trim) {
              queryStr += "&Trim=" + this.makeModel.Trim;
            }
          }
        }
        if (this.httpObj == null) {
          this.httpObj = this.userService.getTaxRate(queryStr).subscribe(
            success => {
              this.showMap = true;

              this.httpObj = null;
              this.showLoader = false;
              resultData = success;
              var pifflag = 0;
              var ruleflag = 0;
              var spds = new Array();
              var stateName;
              var countyName;
              var placeName;
              var tmpHtml = '<div id="printGeotax">';
              if (resultData.confidence < 80) {
                setTimeout(() =>
                  this.modalService.open(this.lowConfidenceModalEl, { size: 'md', ariaLabelledBy: 'modal-basic-title' })
                );
              }
              if (resultData.jurisdiction != undefined && resultData.jurisdiction.spds != undefined) {
                stateName = resultData.jurisdiction.state.name;
                countyName = resultData.jurisdiction.county.name;
                placeName = resultData.jurisdiction.place.name;
                for (var kk = 0; kk < resultData.jurisdiction.spds.length; kk++) {
                  spds[resultData.jurisdiction.spds[kk].districtNumber] = resultData.jurisdiction.spds[kk].districtName;
                }
              }

              if (resultData.latLongFields != undefined) {
                if (this.map) {
                  (<HTMLElement>document.getElementsByClassName('geoApiSampleDemoMap')[0]).style.height = "270px";
                  this.lat = resultData.latLongFields.geometry.coordinates[1];
                  this.long = resultData.latLongFields.geometry.coordinates[0];
                  this.lat = Number(this.lat).toString();
                  this.long = Number(this.long).toString();
                  this.lat = JSON.parse(this.lat);
                  this.long = JSON.parse(this.long);
                  this.addMarker(this.lat, this.long);
                  this.map.panTo(new L.LatLng(this.lat, this.long));
                }
              }
              else {
                (<HTMLElement>document.getElementsByClassName('geoApiSampleDemoMap')[0]).style.height = "0px";
              }
              if (resultData.matchedAddress != undefined && resultData.salesTax['totalTaxRate'] != undefined) {
                tmpHtml += '<div class="printMatchedAddress"><h3 class="floatLeft mt-0"><b>Matched Address</b></h3>';
                tmpHtml += '<div class="leftPad"><div>' + resultData.matchedAddress.mainAddressLine + '</div>';
                tmpHtml += '<div>' + resultData.matchedAddress.addressLastLine + '</div></div><div class="printClear"></div></div>';
                this.mainAddressLine = resultData.matchedAddress.mainAddressLine;
                this.addressLastLine = resultData.matchedAddress.addressLastLine;
                this.showMatchAddress = true;
              }
              tmpHtml += '<div class="printTaxrateAmt"><div><b>Tax Rate Type:</b> ' + taxRateTypeId + '</div>';
              if (purchaseAmount) {
                tmpHtml += '<div><b>Purchase Amount:</b> $' + this.numberWithCommas(parseFloat(purchaseAmount)) + '</div>';
              }
              tmpHtml += '</div><div class="printClear"></div>';
              if (resultData.confidence != undefined) {
                tmpHtml += '<h3 class="printConfidenceScore">Confidence Score: <b class="size">' + resultData.confidence + '%</b></h3>';
                if (resultData.confidence >= 100) {
                  this.highestConScore = true;
                  this.highConScore = false;
                  this.lowConScore = false;
                  this.conTooltipMsg = 'Location is a Building, Parcel or Street match';
                  this.rightposflag = '71px';
                }
                else if (resultData.confidence >= 80 && resultData.confidence < 100) {
                  this.highestConScore = false;
                  this.highConScore = true;
                  this.lowConScore = false;
                  this.conTooltipMsg = 'Location is the center of a ZIP+4 segment';
                  this.rightposflag = '77px';
                }
                else if (resultData.confidence >= 0 && resultData.confidence < 80) {
                  this.highestConScore = false;
                  this.highConScore = false;
                  this.lowConScore = true;
                  this.conTooltipMsg = 'Location is the center of a Census Block Group or ZIP Code';
                  this.rightposflag = '77px';
                }
                this.halfmoon = {
                  minvalue: 0,
                  maxvalue: 100,
                  value: resultData.confidence
                };
                // if(resultData.confidence < 100){
                //   this.rightposflag = false;
                // }
                // else{
                //   this.rightposflag = true;
                // }
                this.isavailable = true;
              }
              if (resultData.salesTax != undefined && resultData.useTax != undefined && resultData.salesTax['totalTaxRate'] != undefined) {
                if (resultData.salesTax != undefined && resultData.salesTax['totalTaxRate'] != undefined) {
                  tmpHtml += '<div class="geotaxRowgap"><table class="table">';
                  var tmpHtml0 = '<tr><th>Sales Tax</th><th class="text-right">Tax Rate</th>';

                  var totalTaxRate = (resultData.salesTax['totalTaxRate'] * 100).toFixed(3);
                  var stateTaxRate = (resultData.salesTax['stateTaxRate'] * 100).toFixed(3);
                  var countyTaxRate = (resultData.salesTax['countyTaxRate'] * 100).toFixed(3);
                  var placeTaxRate = (resultData.salesTax['municipalTaxRate'] * 100).toFixed(3);

                  var tmpHtml1 = '<tr><td>Total Sales Tax';
                  if (resultData.salesTax.specialTaxRulesApplied) {
                    tmpHtml1 += ' *';
                    ruleflag = 1;
                  }
                  tmpHtml1 += '</td><td class="text-right">' + totalTaxRate + '%</td>';
                  var tmpHtml2 = '<tr><td>State Sales Tax';
                  if (stateName) {
                    tmpHtml2 += ' <b>[' + stateName + ']</b>';
                  }
                  tmpHtml2 += '</td><td class="text-right">' + stateTaxRate + '%</td>';
                  var tmpHtml3 = '<tr><td>County Sales Tax';
                  if (countyName) {
                    tmpHtml3 += ' <b>[' + countyName + ']</b>';
                  }
                  tmpHtml3 += '</td><td class="text-right">' + countyTaxRate + '%</td>';
                  var tmpHtml4 = '<tr><td>Municipal Sales Tax';
                  if (placeName) {
                    tmpHtml4 += ' <b>[' + placeName + ']</b>';
                  }
                  tmpHtml4 += '</td><td class="text-right">' + placeTaxRate + '%</td>';
                  if (purchaseAmount) {
                    var totalTaxAmount = resultData.salesTax['totalTaxAmount'];
                    var stateTaxAmount = resultData.salesTax['stateTaxAmount'];
                    var countyTaxAmount = resultData.salesTax['countyTaxAmount'];
                    var placeTaxAmount = resultData.salesTax['municipalTaxAmount'];
                    tmpHtml0 += '<th class="text-right">Tax Amount</th>';
                    tmpHtml1 += '<td class="text-right">$' + this.numberWithCommas(parseFloat(totalTaxAmount)) + '</td>';
                    tmpHtml2 += '<td class="text-right">$' + this.numberWithCommas(stateTaxAmount) + '</td>';
                    tmpHtml3 += '<td class="text-right">$' + this.numberWithCommas(countyTaxAmount) + '</td>';
                    tmpHtml4 += '<td class="text-right">$' + this.numberWithCommas(placeTaxAmount) + '</td>';
                  }
                  tmpHtml0 += '</tr>';
                  tmpHtml1 += '</tr>';
                  tmpHtml2 += '</tr>';
                  tmpHtml3 += '</tr>';
                  tmpHtml4 += '</tr>';
                  tmpHtml += '<thead>' + tmpHtml0 + '</thead><tbody>' + tmpHtml1 + tmpHtml2 + tmpHtml3 + tmpHtml4;
                  if (resultData.salesTax.spdsTax !== undefined && resultData.salesTax.spdsTax.length != 0) {
                    tmpHtml += '</tbody><thead><tr><th class="topborder" colspan="';
                    if (purchaseAmount) {
                      tmpHtml += '3';
                    }
                    else {
                      tmpHtml += '2';
                    }
                    tmpHtml += '">Special Purpose Districts Tax</th></tr></thead><tbody>';
                    for (var j = 0; j < resultData.salesTax.spdsTax.length; j++) {
                      var districtNumber = resultData.salesTax.spdsTax[j].districtNumber;
                      var districtCode = resultData.jurisdiction.spds[j].districtCode;
                      var name = spds[districtNumber];
                      var value = (resultData.salesTax.spdsTax[j].taxRate * 100).toFixed(3);
                      if (purchaseAmount) {
                        var amount = (resultData.salesTax.spdsTax[j].taxAmount);
                        if (districtCode == "PIF") {
                          tmpHtml += '<tr><td>' + name + '<span class="taxResultHeading">' + ' **' + '</span></td><td class="text-right">' + value + '%</td><td class="text-right">$' + this.numberWithCommas(amount) + '</td></tr>';
                          pifflag = 1;
                        }
                        else {
                          tmpHtml += '<tr><td>' + name + '</td><td class="text-right">' + value + '%</td><td class="text-right">$' + this.numberWithCommas(amount) + '</td></tr>';
                        }
                      }
                      else {
                        if (districtCode == "PIF") {
                          tmpHtml += '<tr><td>' + name + '<span class="taxResultHeading">' + ' **' + '</span></td><td class="text-right">' + value + '%</td></tr>';
                          pifflag = 1;
                        }
                        else {
                          tmpHtml += '<tr><td>' + name + '</td><td class="text-right">' + value + '%</td></tr>';
                        }
                      }
                    }
                  }
                  tmpHtml += '</tbody></table>';
                  if (purchaseAmount) {
                    tmpHtml += '<div class="totalWithTax"><b>Total Amount (incl. taxes) = $';
                    tmpHtml += this.numberWithCommas(parseFloat(purchaseAmount) + parseFloat(resultData.salesTax['totalTaxAmount']));
                    tmpHtml += '</b></div>';
                  }
                  tmpHtml += '</div>';
                }
                if (resultData.useTax != undefined && resultData.useTax['totalTaxRate'] != undefined) {
                  if (purchaseAmount) {
                    tmpHtml += '<div>';
                  }
                  else {
                    tmpHtml += '<div class="geotaxRowgap">';
                  }
                  tmpHtml += '<table class="table">';
                  var tmpHtml0 = '<tr><th>Use Tax</th><th class="text-right">Tax Rate</th>';

                  var totalTaxRate = (resultData.useTax['totalTaxRate'] * 100).toFixed(3);
                  var stateTaxRate = (resultData.useTax['stateTaxRate'] * 100).toFixed(3);
                  var countyTaxRate = (resultData.useTax['countyTaxRate'] * 100).toFixed(3);
                  var placeTaxRate = (resultData.useTax['municipalTaxRate'] * 100).toFixed(3);

                  var tmpHtml1 = '<tr><td>Total Use Tax';
                  if (resultData.useTax.specialTaxRulesApplied) {
                    tmpHtml1 += ' *';
                    ruleflag = 1;
                  }
                  tmpHtml1 += '</td><td class="text-right">' + totalTaxRate + '%</td>';
                  var tmpHtml2 = '<tr><td>State Use Tax';
                  if (stateName) {
                    tmpHtml2 += ' <b>[' + stateName + ']</b>';
                  }
                  tmpHtml2 += '</td><td class="text-right">' + stateTaxRate + '%</td>';
                  var tmpHtml3 = '<tr><td>County Use Tax';
                  if (countyName) {
                    tmpHtml3 += ' <b>[' + countyName + ']</b>';
                  }
                  tmpHtml3 += '</td><td class="text-right">' + countyTaxRate + '%</td>';
                  var tmpHtml4 = '<tr><td>Municipal Use Tax';
                  if (placeName) {
                    tmpHtml4 += ' <b>[' + placeName + ']</b>';
                  }
                  tmpHtml4 += '</td><td class="text-right">' + placeTaxRate + '%</td>';
                  if (purchaseAmount) {
                    var totalTaxAmount = resultData.useTax['totalTaxAmount'];
                    var stateTaxAmount = resultData.useTax['stateTaxAmount'];
                    var countyTaxAmount = resultData.useTax['countyTaxAmount'];
                    var placeTaxAmount = resultData.useTax['municipalTaxAmount'];
                    tmpHtml0 += '<th class="text-right">Tax Amount</th>';
                    tmpHtml1 += '<td class="text-right">$' + this.numberWithCommas(totalTaxAmount) + '</td>';
                    tmpHtml2 += '<td class="text-right">$' + this.numberWithCommas(stateTaxAmount) + '</td>';
                    tmpHtml3 += '<td class="text-right">$' + this.numberWithCommas(countyTaxAmount) + '</td>';
                    tmpHtml4 += '<td class="text-right">$' + this.numberWithCommas(placeTaxAmount) + '</td>';
                  }
                  tmpHtml0 += '</tr>';
                  tmpHtml1 += '</tr>';
                  tmpHtml2 += '</tr>';
                  tmpHtml3 += '</tr>';
                  tmpHtml4 += '</tr>';
                  tmpHtml += '<thead>' + tmpHtml0 + '</thead><tbody>' + tmpHtml1 + tmpHtml2 + tmpHtml3 + tmpHtml4;
                  if (resultData.useTax.spdsTax !== undefined && resultData.useTax.spdsTax.length != 0) {
                    tmpHtml += '</tbody><thead><tr><th class="topborder" colspan="';
                    if (purchaseAmount) {
                      tmpHtml += '3';
                    }
                    else {
                      tmpHtml += '2';
                    }
                    tmpHtml += '">Special Purpose Districts Tax</th></tr></thead><tbody>';
                    for (var j = 0; j < resultData.useTax.spdsTax.length; j++) {
                      var districtNumber = resultData.useTax.spdsTax[j].districtNumber;
                      var districtCode = resultData.jurisdiction.spds[j].districtCode;
                      var name = spds[districtNumber];
                      var value = (resultData.useTax.spdsTax[j].taxRate * 100).toFixed(3);
                      if (purchaseAmount) {
                        var amount = (resultData.useTax.spdsTax[j].taxAmount);
                        if (districtCode == "PIF") {
                          tmpHtml += '<tr><td>' + name + '<span class="taxResultHeading">' + ' **' + '</span></td><td class="text-right">' + value + '%</td><td class="text-right">$' + this.numberWithCommas(amount) + '</td></tr>';
                          pifflag = 1;
                        }
                        else {
                          tmpHtml += '<tr><td>' + name + '</td><td class="text-right">' + value + '%</td><td class="text-right">$' + this.numberWithCommas(amount) + '</td></tr>';
                        }
                      }
                      else {
                        if (districtCode == "PIF") {
                          tmpHtml += '<tr><td>' + name + '<span class="taxResultHeading">' + ' **' + '</span></td><td class="text-right">' + value + '%</td></tr>';
                          pifflag = 1;
                        }
                        else {
                          tmpHtml += '<tr><td>' + name + '</td><td class="text-right">' + value + '%</td></tr>';
                        }
                      }
                    }
                  }
                  tmpHtml += '</tbody></table>';
                  if (purchaseAmount) {
                    tmpHtml += '<div class="totalWithTax"><b>Total Amount (incl. taxes) = $';
                    tmpHtml += this.numberWithCommas(parseFloat(purchaseAmount) + parseFloat(resultData.useTax['totalTaxAmount']));
                    tmpHtml += '</b></div>';
                  }
                  tmpHtml += '</div>';
                }
                // if(resultData.salesTax['totalTaxRate']==undefined)
                // {

                //   tmpHtml += '</h3><div class="clear"></div>';
                //   tmpHtml += '</h3><div class="clear"></div>';
                //   tmpHtml += '</h3><div class="clear"></div>';
                //   tmpHtml += '</h3><div class="clear"></div>';
                //   tmpHtml += '</h3><div class="clear"></div>';
                //   tmpHtml += '<div><b>No Tax Found</b></div>';
                // }

                if (ruleflag == 1) {
                  tmpHtml += '<div class="taxResultHeading bottomPad">* The Tax Amounts are calculated using the complex rates and rules required by the jurisdictions shown above.  These amounts may not equal the purchase amount multiplied by the tax rates shown.</div>';
                }
                if (pifflag == 1) {
                  tmpHtml += '<div class="taxResultHeading bottomPad">** Public Improvement Fees/Project Improvement Fees (PIF) are only subject to collection/remittance by retailers physically located within the PIF developments, conducting retail sales, & services. Deliveries made into these PIF developments are subject to the standard municipal sales/use tax rate shown above. Please contact the listed municipality if you have any questions regarding the tax rates.</div>';
                }
                tmpHtml += '</div>';
                document.getElementById('taxRateResult').innerHTML = tmpHtml;
                if (this.isdevice) {
                  document.getElementById("taxRateResult").scrollIntoView(true);
                }
                setTimeout(() => {
                  this.dialInit();
                }, 3000);
              }
              else {

                this.showMap = false;
                document.getElementById('taxRateResult').innerHTML = '<div class="alert alert-danger errmargin">Tax details not available for this location.</div>';
                this.showMatchAddress = false;
              }
            },
            error => {
              if (error.error.error == 'Cookie tempered') {
                window.location.href = '/signout';
                return;
              }
              this.showMap = false;
              this.httpObj = null;
              this.showLoader = false;
              if (error.status == 403) {
                if (this.planId.includes('Free')) {
                  document.getElementById('taxRateResult').innerHTML = "";
                  this.showMatchAddress = false;
                  setTimeout(() =>
                    this.modalService.open(this.freeOverageModalEl, { size: 'md', ariaLabelledBy: 'modal-basic-title' })
                  );
                }
              }
              else if (error.status == 401) {
                if (this.userExpiredMsg == "") {
                  this.userExpiredMsg = 'Invalid User Account';
                }
                document.getElementById('taxRateResult').innerHTML = '<div class="alert alert-danger errmargin">' + this.userExpiredMsg + '</div>';
                this.showMatchAddress = false;
              }
              else if (error.error.message.errors[0].errorCode != 'ACCESS_ERROR_01') {
                if (error.error.message.errors[0]) {
                  document.getElementById('taxRateResult').innerHTML = '<div class="alert alert-danger errmargin">' + error.error.message.errors[0].errorDescription + '</div>';
                  this.showMatchAddress = false;
                }
                else {
                  document.getElementById('taxRateResult').innerHTML = '<div class="alert alert-danger errmargin">' + error.statusText + '</div>';
                  this.showMatchAddress = false;
                }
              }
              else {
                document.getElementById('taxRateResult').innerHTML = '<div class="alert alert-danger errmargin">' + error.error.message.errors[0].errorDescription + '</div>';
                this.showMatchAddress = false;
              }
            }
          );
        }
      }
      else {
        this.showMap = false;
        this.highestConScore = false;
        this.highConScore = false;
        this.lowConScore = false;
        document.getElementById('taxRateResult').innerHTML = '<div class="alert alert-danger errmargin">Fill an address first.</div>';
        this.showMatchAddress = false;
        this.showLoader = false;
      }
    }
    else {
      setTimeout(() =>
        this.modalService.open(this.accountStatusModalEl, { size: 'md', ariaLabelledBy: 'modal-basic-title' })
      );
    }
  };
  clickFile = function () {
    this.batchfilename = "";
    let input = (<HTMLInputElement>document.getElementById('taxAmountFile'));
    input.value = "";
  };
  uploadFile = function () {
    if (this.userExpiredMsg == '') {
    this.batchErr = "";
    this.batchModalErr = "";
    this.fileDataArr = [];
    this.columnArr = [];
    let input = (<HTMLInputElement>document.getElementById('taxAmountFile'));
    if (input.files.length != 0) {
      this.batchfilename = input.files[0].name;
    }
    else {
      this.batchfilename = "";
      return;
    }
    this.batchfilenamedup = this.batchfilename;
    let filetypeArr = this.batchfilename.split('.');
    let filetype = filetypeArr[filetypeArr.length - 1].toLowerCase();
    if (filetype != 'csv') {
      this.isBatchResultReady = false;
      this.batchErr = "The file you uploaded is of wrong format. We support CSV format only.";
      return;
    }
    let filesize = input.files[0].size / 1024;
    if (filesize > 5000) {
      this.isBatchResultReady = false;
      this.batchErr = "The file you uploaded is larger than 5 MB. Please remove extra addresses or information from the file and try uploading again.";
      return;
    }
    let reader = new FileReader();
    reader.onload = () => {
      let text = reader.result;
      let json = this.csvJSON(text);
      if (json) {
        this.totalPayLoadCount = json.length;
        if (this.totalPointsUsed > this.quota) {
          this.modalwarning = 'Warning! Your monthly transaction quota is exhausted. If you choose to confirm, overage charges will be applied. ';
        }
        else {
          if (this.totalPayLoadCount > (this.quota - this.totalPointsUsed)) {
            this.modalwarning = 'Warning! The file you uploaded requires more than the ' + (this.quota - this.totalPointsUsed) + ' transactions you have left. If you choose to confirm, overage charges will be applied for the additional records. ';
          }
        }
        this.fileDataArr = json;
      }
    };
    reader.readAsText(input.files[0]);
  }
  else {
    setTimeout(() =>
      this.modalService.open(this.accountStatusModalEl, { size: 'md', ariaLabelledBy: 'modal-basic-title' })
    );
  }
  };
  csvJSON = function (csv: any) {
    if (csv == "") {
      this.isBatchResultReady = false;
      this.batchErr = "There is no address header available at the start of CSV file. Please add the header and try again.";
      return;
    }
    csv = csv.replace(/,"/g, ',_backdblquot_').replace(/",/g, '_backdblquot_,').replace(/"/g, "_dblquot_");
    let lines = csv.replace(/,_backdblquot_/g, ',\\"').replace(/_backdblquot_,/g, '\\",').split("\n");
    let result = [];
    let headers = lines[0].trim().split(",");
    let tmpHeader = [];
    let tmpFlag = true;
    let regexp = /^[a-zA-Z0-9_ ]+$/;
    for (var i = 0; i < headers.length; i++) {
      if (headers[i] != "") {
        if (headers[i].search(regexp) == -1) {
          tmpFlag = false;
          break;
        }
      }
      tmpHeader.push(headers[i].toLowerCase());
    }
    if (!tmpFlag) {
      this.isBatchResultReady = false;
      this.batchErr = "Header names at the start of CSV file can only contain alphanumeric, space and underscore. Please remove other special characters from header and try again.";
      return;
    }
    var uniqueHeader = tmpHeader.filter(function (value, index, self) {
      if (value == "") {
        return true;
      }
      return self.indexOf(value) === index;
    });
    if (uniqueHeader.length != tmpHeader.length) {
      this.isBatchResultReady = false;
      this.batchErr = "Duplicate header names are not allowed. Please assign a unique header name to each column of CSV and try again.";
      return;
    }
    var uniqueHeader = tmpHeader.filter(function (value, index, self) {
      return self.indexOf(value) === index;
    });
    if (uniqueHeader.length == 1 && uniqueHeader[0] == "") {
      this.isBatchResultReady = false;
      this.batchErr = "There is no address header available at the start of CSV file. Please add the header and try again.";
      return;
    }
    for (let i = 1; i < lines.length - 1; i++) {
      let obj = {};
      //let currentline = lines[i].split(",");
      let inputStr = lines[i].replace(/,'/g, ',\\"').replace(/',/g, '\\",').replace(/'/g, "_quot_");
      let currentline = inputStr.split(/,(?=(?:(?:[^'"]*(?:'|")){2})*[^'"]*$)/);
      if (currentline.length == headers.length && currentline[1] != "") {
        for (let j = 0; j < headers.length; j++) {
          obj[headers[j]] = currentline[j].replace(/\\"/g, "").replace(/_quot_/g, "'").replace(/_dblquot_/g, '"').trim();
        }
        result.push(obj);
      }
      else {
        this.isBatchResultReady = false;
        this.batchErr = "Error in (AddressLine) at row number " + (i + 1) + ".";
        return;
      }
    }
    if (result.length == 0) {
      this.isBatchResultReady = false;
      this.batchErr = "No addresses found in uploaded file.";
      return;
    }
    if (result.length > 1000) {
      this.isBatchResultReady = false;
      this.batchErr = "The file you uploaded contains more than 1000 addresses. Please remove extra addresses and try again.";
      return;
    }
    this.columnArr = headers;
    return result;
  };
  beginBatchProcess = function () {
    if (this.batchfilename == "") {
      this.isBatchResultReady = false;
      this.batchErr = "Choose a file to begin process.";
      return;
    }
    if(this.entitlementsStatus == 'cancelled') {
        setTimeout(() =>
            this.modalService.open(this.accountStatusModalEl, { size: 'md', ariaLabelledBy: 'modal-basic-title' })
        );
        return;
    }
    if (this.batchErr == "") {
      this.idCol = "";
      this.addressCol = "";
      this.cityCol = "";
      this.stateCol = "";
      this.zipCol = "";
      this.amountCol = "";
      for (var i = 0; i < this.columnArr.length; i++) {
        switch (this.columnArr[i].toLowerCase()) {
          case 'id':
            this.idCol = this.columnArr[i];
            break;
          case 'addressline':
            this.addressCol = this.columnArr[i];
            break;
          case 'city':
            this.cityCol = this.columnArr[i];
            break;
          case 'state':
            this.stateCol = this.columnArr[i];
            break;
          case 'zip':
            this.zipCol = this.columnArr[i];
            break;
          case 'amount':
            this.amountCol = this.columnArr[i];
            break;
        }
      }
      setTimeout(() =>
        this.modalService.open(this.batchMapModalEl, { size: 'md', ariaLabelledBy: 'modal-basic-title' })
      );
    }
  };
  getGeoTaxBatch = function () {
    if (this.addressCol) {
      (<HTMLElement>document.getElementById('closeConfirmModal')).click();
      this.showLoader = true;
      this.batchModalErr = "";
      this.successPayLoadCount = 0;
      this.errorPayLoadCount = 0;
      this.batchResponse = [];
      this.isBatchResultReady = false;
      this.batchErr = "";
      let payload = {
        taxRateTypeId: this.currentTaxRate,
        mainAddressLine: this.addressCol,
        fileData: this.fileDataArr,
        areaName3: this.cityCol,
        areaName1: this.stateCol,
        postCode1: this.zipCol,
        purchaseAmount: this.amountCol,
        id: this.idCol
      };
      this.userService.getGeoTaxBatch(payload).subscribe(
        success => {
          this.showLoader = false;
          this.isBatchResultReady = true;
          this.lookupfilename = this.batchfilename;
          this.totalResCount = success.total;
          this.successPayLoadCount = success.matched;
          this.errorPayLoadCount = success.unmatched;
          this.batchResponse = success.batchResponse;
          setTimeout(() => {
            this.dialInit();
          }, 3000);
        },
        error => {
          if (error.error.error == 'Cookie tempered') {
            window.location.href = '/signout';
            return;
          }
          this.showLoader = false;
          this.batchErr = this.userExpiredMsg;
          if (this.userExpiredMsg == "") {
            this.batchErr = error.error.message.errors[0].errorDescription;
            if (this.batchErr == "Bad Request") {
              this.batchErr = error.error.message.errors[0].error + "You need to run batch again";
            }
          }
        }
      );
    }
    else {
      this.batchModalErr = 'Required field (AddressLine) cannot be left blank.';
    }
  };
  downloadBatchResponse = function () {
    this.batchColumns = {
      id: 'Id', inputAddress: 'Input Address', amount: 'Input Amount', confidence: 'Confidence', matchedAddress: 'Matched Address', salesTaxTotalTaxRate: 'Total Sales Tax Rate', salesTaxTotalTaxAmount: 'Total Sales Tax Amount', useTaxTotalTaxRate: 'Total Use Tax Rate', useTaxTotalTaxAmount: 'Total Use Tax Amount', state: 'State Name', salesTaxStateTaxRate: 'State Sales Tax Rate', salesTaxStateTaxAmount: 'State Sales Tax Amount', useTaxStateTaxRate: 'State Use Tax Rate', useTaxStateTaxAmount: 'State Use Tax Amount', county: 'County Name', salesTaxCountyTaxRate: 'County Sales Tax Rate', salesTaxCountyTaxAmount: 'County Sales Tax Amount', useTaxCountyTaxRate: 'County Use Tax Rate', useTaxCountyTaxAmount: 'County Use Tax Amount', municipal: 'Municipality Name', salesTaxMunicipalTaxRate: 'Municipal Sales Tax Rate', salesTaxMunicipalTaxAmount: 'Municipal Sales Tax Amount', useTaxMunicipalTaxRate: 'Municipal Use Tax Rate', useTaxMunicipalTaxAmount: 'Municipal Use Tax Amount', spds_1_name: 'Special District 1 Name', salesTaxSpds_1_TaxRate: 'Special District 1 Sales Tax Rate', salesTaxSpds_1_TaxAmount: 'Special District 1 Sales Tax Amount', useTaxSpds_1_TaxRate: 'Special District 1 Use Tax Rate', useTaxSpds_1_TaxAmount: 'Special District 1 Use Tax Amount', spds_2_name: 'Special District 2 Name', salesTaxSpds_2_TaxRate: 'Special District 2 Sales Tax Rate', salesTaxSpds_2_TaxAmount: 'Special District 2 Sales Tax Amount', useTaxSpds_2_TaxRate: 'Special District 2 Use Tax Rate', useTaxSpds_2_TaxAmount: 'Special District 2 Use Tax Amount', spds_3_name: 'Special District 3 Name', salesTaxSpds_3_TaxRate: 'Special District 3 Sales Tax Rate', salesTaxSpds_3_TaxAmount: 'Special District 3 Sales Tax Amount', useTaxSpds_3_TaxRate: 'Special District 3 Use Tax Rate', useTaxSpds_3_TaxAmount: 'Special District 3 Use Tax Amount', spds_4_name: 'Special District 4 Name', salesTaxSpds_4_TaxRate: 'Special District 4 Sales Tax Rate', salesTaxSpds_4_TaxAmount: 'Special District 4 Sales Tax Amount', useTaxSpds_4_TaxRate: 'Special District 4 Use Tax Rate', useTaxSpds_4_TaxAmount: 'Special District 4 Use Tax Amount', spds_5_name: 'Special District 5 Name', salesTaxSpds_5_TaxRate: 'Special District 5 Sales Tax Rate', salesTaxSpds_5_TaxAmount: 'Special District 5 Sales Tax Amount', useTaxSpds_5_TaxRate: 'Special District 5 Use Tax Rate', useTaxSpds_5_TaxAmount: 'Special District 5 Use Tax Amount', spds_6_name: 'Special District 6 Name', salesTaxSpds_6_TaxRate: 'Special District 6 Sales Tax Rate', salesTaxSpds_6_TaxAmount: 'Special District 6 Sales Tax Amount', useTaxSpds_6_TaxRate: 'Special District 6 Use Tax Rate', useTaxSpds_6_TaxAmount: 'Special District 6 Use Tax Amount', spds_7_name: 'Special District 7 Name', salesTaxSpds_7_TaxRate: 'Special District 7 Sales Tax Rate', salesTaxSpds_7_TaxAmount: 'Special District 7 Sales Tax Amount', useTaxSpds_7_TaxRate: 'Special District 7 Use Tax Rate', useTaxSpds_7_TaxAmount: 'Special District 7 Use Tax Amount', spds_8_name: 'Special District 8 Name', salesTaxSpds_8_TaxRate: 'Special District 8 Sales Tax Rate', salesTaxSpds_8_TaxAmount: 'Special District 8 Sales Tax Amount', useTaxSpds_8_TaxRate: 'Special District 8 Use Tax Rate', useTaxSpds_8_TaxAmount: 'Special District 8 Use Tax Amount', spds_9_name: 'Special District 9 Name', salesTaxSpds_9_TaxRate: 'Special District 9 Sales Tax Rate', salesTaxSpds_9_TaxAmount: 'Special District 9 Sales Tax Amount', useTaxSpds_9_TaxRate: 'Special District 9 Use Tax Rate', useTaxSpds_9_TaxAmount: 'Special District 9 Use Tax Amount', spds_10_name: 'Special District 10 Name', salesTaxSpds_10_TaxRate: 'Special District 10 Sales Tax Rate', salesTaxSpds_10_TaxAmount: 'Special District 10 Sales Tax Amount', useTaxSpds_10_TaxRate: 'Special District 10 Use Tax Rate', useTaxSpds_10_TaxAmount: 'Special District 10 Use Tax Amount'
    };
    let replacer = (key, value) => value === null ? "" : value // specify how you want to handle null values here
    let header = Object.keys(this.batchColumns);
    let headerName = Object.values(this.batchColumns);
    let csvData = this.batchResponse.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    csvData.unshift(headerName.join(','));
    csvData = csvData.join('\r\n');

    let today = new Date();
    let dd = ("0" + today.getDate()).slice(-2);
    let mm = ("0" + (today.getMonth() + 1)).slice(-2);
    let yyyy = today.getFullYear();
    let downloadDate = dd + '_' + mm + '_' + yyyy;

    let blob = new Blob(['\ufeff' + csvData], {
      type: 'text/csv;charset=utf-8;'
    });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", "GeoTAX_" + this.currentTaxRate + "_" + downloadDate + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  };
}
